module.exports = __webpack_public_path__ + "img/reaction_dislike.6ef810e.svg";